export default __webpack_public_path__ + "static/media/181.206362b2.jpg";